import { render, staticRenderFns } from "./ChallengerDetailPartner.vue?vue&type=template&id=4fd4c783&scoped=true"
import script from "./ChallengerDetailPartner.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailPartner.vue?vue&type=script&lang=ts"
import style0 from "./ChallengerDetailPartner.vue?vue&type=style&index=0&id=4fd4c783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd4c783",
  null
  
)

export default component.exports